export default __webpack_public_path__ + "static/seeds-logo-main-cec8a372ffaac541d442b3e5ebc45d8d.png";